import _isString from 'lodash/isString'; /**
                                          * @author Kuitos
                                          * @homepage https://github.com/kuitos/
                                          * @since 2017-07-12
                                          */

import { v4 } from 'uuid';
import { storeSymbol } from '../meta';
import namedModelDecorator from './namedModelDecorator';
export default (function (arg1) {
    // if decorator named
    // eg. @Store('xStore') class Store {}
    if (_isString(arg1)) {
        return namedModelDecorator(arg1, storeSymbol);
    }
    var name = v4();
    return namedModelDecorator(name, storeSymbol)(arg1);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/mmlpx/esm/core/dependency-inject/decorators/Store.js
// module id = null
// module chunks = 